import { createTheme, type ThemeOptions } from "@mui/material/styles";
// Import type augmentation for theme.vars CSS variables
import type {} from "@mui/material/themeCssVarsAugmentation";
import labelStyles from "./figma-label-styles";
import figmaTheme from "./figma-theme";
import themeOverrides from "./figma-theme-overrides";

// Extend MUI Theme to include custom properties
declare module "@mui/material/styles" {
  interface TypeBackground {
    contentBackground: string;
  }

  interface TypographyVariants {
    label1: React.CSSProperties;
    label2: React.CSSProperties;
    label3: React.CSSProperties;
    label4: React.CSSProperties;
    fontWeightSemiBold: number;
  }

  interface TypographyVariantsOptions {
    label1?: React.CSSProperties;
    label2?: React.CSSProperties;
    label3?: React.CSSProperties;
    label4?: React.CSSProperties;
    fontWeightSemiBold?: number;
  }

  interface Theme {
    customFontSizes?: {
      10: string;
      12: string;
      13: string;
      14: string;
      15: string;
      16: string;
      20: string;
      24: string;
      28: string;
      32: string;
      40: string;
      68: string;
    };
  }

  interface ThemeOptions {
    customFontSizes?: {
      10?: string;
      12?: string;
      13?: string;
      14?: string;
      15?: string;
      16?: string;
      20?: string;
      24?: string;
      28?: string;
      32?: string;
      40?: string;
      68?: string;
    };
  }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    label1: true;
    label2: true;
    label3: true;
    label4: true;
  }
}

// Create the Figma theme with color schemes for dark mode support
export const figma = createTheme({
  ...figmaTheme,
  cssVariables: {
    colorSchemeSelector: "data",
  },
  colorSchemes: figmaTheme.colorSchemes as ThemeOptions["colorSchemes"],
  shadows: figmaTheme.shadows as ThemeOptions["shadows"],
  typography: {
    ...figmaTheme.typography,
    ...themeOverrides.typography,
    ...labelStyles.typography,
  },
  customFontSizes: themeOverrides.customFontSizes,
  components: figmaTheme.components as ThemeOptions["components"],
});
